import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_switch = _resolveComponent("van-switch");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_button = _resolveComponent("van-button");
  const _component_CodeDataPickerCpt = _resolveComponent("CodeDataPickerCpt");
  const _component_AddrDataPickerCpt = _resolveComponent("AddrDataPickerCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, null, {
    footer: _withCtx(() => [_createVNode(_component_van_button, {
      style: {
        "width": "100%"
      },
      type: "primary",
      loading: $data.btnLoading,
      onClick: $options.onSaveClick
    }, {
      default: _withCtx(() => [_createTextVNode(" 保存 ")]),
      _: 1
    }, 8, ["loading", "onClick"])]),
    default: _withCtx(() => [_createVNode(_component_van_form, {
      ref: "form",
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell_group, {
        title: "地址信息"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: $data.form.addressType.text,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.addressType.text = $event),
          readonly: "",
          clickable: "",
          name: "addressType",
          label: "地址类型",
          placeholder: "地址类型",
          rules: [{
            required: false,
            message: '请选择地址类型'
          }],
          onClick: _cache[1] || (_cache[1] = $event => $options.onPickerSelectClick('addressType'))
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.pcc,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.pcc = $event),
          readonly: "",
          clickable: "",
          name: "pcc",
          label: "省市区",
          placeholder: "省市区",
          rules: [{
            required: false,
            message: '请选择地址省市区'
          }],
          onClick: _cache[3] || (_cache[3] = $event => $options.onPickerAddrDataSelectClick(`pcc`))
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.street,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.street = $event),
          autosize: "",
          rows: "1",
          type: "textarea",
          name: "street",
          label: "详细地址",
          placeholder: "详细地址",
          rules: [{
            required: false,
            message: '请输入详细地址'
          }]
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          name: "isDefault",
          label: "默认地址"
        }, {
          input: _withCtx(() => [_createVNode(_component_van_switch, {
            modelValue: $data.form.isDefault,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.isDefault = $event),
            size: "20",
            "active-value": "Y",
            "inactive-value": "N"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_van_divider)]),
      _: 1
    }, 8, ["onSubmit"]), _createVNode(_component_CodeDataPickerCpt, {
      ref: "CodeDataPickerCpt",
      onOnSelectedChange: $options.onPickerSelected
    }, null, 8, ["onOnSelectedChange"]), _createVNode(_component_AddrDataPickerCpt, {
      ref: "AddrDataPickerCpt",
      onOnSelectedChange: $options.onPickerAddrDataSelected
    }, null, 8, ["onOnSelectedChange"])]),
    _: 1
  });
}